import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[loadSigType]'
})
export class LoadSigTypeDirective {

  constructor(public viewContainerRef?: ViewContainerRef) { }

}
